import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface AttributeTextStringModel {
  [key: string]: string | number | boolean | undefined;
  stringId?: number;
  searchOrder?: number;
  isNew?: boolean;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portuguese?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetAttributeTextStringsRequest {}

class GetAttributeTextStringsResponse {
  attributeTextStrings?: AttributeTextStringModel[];
}

class CreateAttributeTextStringRequest {
  attributeTextStringModel?: AttributeTextStringModel;
}

class CreateAttributeTextStringResponse {
  stringId?: number;
}

class UpdateAttributeTextStringRequest {
  stringId?: number;
  attributeTextStringModel?: AttributeTextStringModel;
}

class DeleteAttributeTextStringRequest {
  stringId?: number;
}

class AddNewAttributeTextsRequest {
  constructor(public newAttributeTexts: string[]) {}
}

export const glossaryAttributeTextStringApi = {
  async getAttributeTextStrings(): Promise<Result<AttributeTextStringModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetAttributeTextStringsResponse>(
        "GetAttributeTextStrings",
        {} as GetAttributeTextStringsRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.attributeTextStrings ?? [] };
    }

    return response;
  },

  async createAttributeTextString(
    attributeTextStringModel: AttributeTextStringModel,
  ): Promise<Result<number | undefined>> {
    let response =
      await backendApi.sendAndGetResponseAsync<CreateAttributeTextStringResponse>(
        "CreateAttributeTextString",
        {
          attributeTextStringModel: attributeTextStringModel,
        } as CreateAttributeTextStringRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.stringId ?? undefined };
    }

    TrimValidationFields(response.problem, "AttributeTextStringModel");

    return response;
  },

  async updateAttributeTextString(
    stringId?: number,
    attributeTextStringModel?: AttributeTextStringModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateAttributeTextString", {
      stringId: stringId,
      attributeTextStringModel: attributeTextStringModel,
    } as UpdateAttributeTextStringRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "AttributeTextStringModel");

    return response;
  },

  async deleteAttributeTextString(stringId?: number): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteAttributeTextString", {
      stringId: stringId,
    } as DeleteAttributeTextStringRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },

  async addNewAttributeTexts(
    newAttributeTexts: string[],
  ): Promise<Result<any>> {
    return await backendApi.sendAsync(
      "AddNewAttributeTexts",
      new AddNewAttributeTextsRequest(newAttributeTexts),
    );
  },
};
